import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstanceDetailsComponent } from './instance-details.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatTabsModule } from '@angular/material/tabs';
import {TableModule} from 'src/app/table/table.module';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import {MatMenuModule} from '@angular/material/menu';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { InstanceDetailsAddRouteComponent } from './instance-details-add-route/instance-details-add-route.component';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ErrorModule } from '../error/error.module';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {PaginatorModule} from 'src/app/components/paginator/paginator.module';
import { GenericErrorModule } from '../generic-error/generic-error.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule} from '@angular/material/core';
import { InstanceDatePickerComponent } from './instance-date-picker/instance-date-picker.component';
import {MatDialogModule} from '@angular/material/dialog';
import { PopupHostDirective } from 'src/app/directives/host.directive';
import { VerifypopupModule } from 'src/app/components/verifypopup/verifypopup.module';
import { SkiptestPopupModule } from 'src/app/components/skiptest-popup/skiptest-popup.module';
import { ConfigurationDetailsModule } from '../configuration-details/configuration-details.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { InstanceApplyConfigurationComponent } from './instance-apply-configuration/instance-apply-configuration.component';
import { AddSshKeyComponent } from './add-ssh-key/add-ssh-key.component';
import { SearchFilterModule } from '../search-filter/search-filter.module';
import {MatSortModule} from '@angular/material/sort';
import { DynamicFormModule } from '../dynamic-form-cob/dynamic-form.module';
import { DbBackupFormComponent } from './db-backup-form/db-backup-form.component';
import { CobDetailsComponent } from './cob-details/cob-details.component';
import { InstanceExecuteRvtComponent } from './instance-execute-rvt/instance-execute-rvt.component';
import { DatabaseBackupComponent } from '../database-backup/database-backup.component';
import { CommonTableModule } from '../table/table.module';
import { AddEncKeyComponent } from './add-enc-key/add-enc-key.component';
import { DatepickerModule } from 'src/app/components/datepicker/datepicker.module';
import { CloudResourcesInventoryComponent } from './cloud-resources-inventory/cloud-resources-inventory.component';
import { InventoryKubernetesModule } from '../inventory-kubernetes/inventory-kubernetes.module';
import { DbBackupDetailsComponent } from './db-backup-details/db-backup-details.component';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { monthYearPickerModule } from '../month-year-picker/month-year-picker.module';
import { TimeTakenPieModule } from 'src/app/components/time-taken-info-pie/time-taken-info-pie.module';
import { ActivityDetailsModule } from '../activity-details/activity-details.module';
import { EnvironmentPaginatorrModule } from 'src/app/main/environment-details/environment-paginator/environment-paginator.module';
import { EnvironmentTableModule } from 'src/app/main/environment-details/environment-table/environment-table.module';
import { SizingProgressDialogModule } from '../sizing-progress-dialog/sizing-progress-dialog.module';
import { SizingConfirmDialogModule } from './../sizing-confirm-dialog/sizing-confirm-dialog.module';
@NgModule({
  declarations: [
    InstanceDetailsComponent,
    InstanceDetailsAddRouteComponent,
    InstanceDatePickerComponent,
    PopupHostDirective,
    InstanceApplyConfigurationComponent,
    AddSshKeyComponent,
    DbBackupFormComponent,
    CobDetailsComponent,
    InstanceExecuteRvtComponent,
    DatabaseBackupComponent,
    AddEncKeyComponent,
    CloudResourcesInventoryComponent,
    DbBackupDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    MatTabsModule,
    TableModule,
    SidenavHeaderModule,
    ClipboardModule,
    MatDividerModule,
    MatExpansionModule,
    MatTooltipModule,
    ToolbarModule,
    MatMenuModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatProgressSpinnerModule,
    ErrorModule,
    MatSelectModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    PaginatorModule,
    GenericErrorModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatDialogModule,
    VerifypopupModule,
    SkiptestPopupModule,
    ConfigurationDetailsModule,
    NgxSkeletonLoaderModule,
    SearchFilterModule,
    MatSortModule,
    DynamicFormModule,
    CommonTableModule,
    DatepickerModule,
    InventoryKubernetesModule,
    ActivityDetailsModule,
    NgxEchartsModule.forRoot({
      echarts
    }),
    monthYearPickerModule,
    TimeTakenPieModule,
    EnvironmentPaginatorrModule,
    EnvironmentTableModule,
    SizingProgressDialogModule,
    SizingConfirmDialogModule
    ],
  exports: [
    InstanceDetailsComponent,
    InstanceDatePickerComponent,
    InstanceApplyConfigurationComponent,
    InstanceExecuteRvtComponent
  ]
})
export class InstanceDetailsModule { }
